import React, { useCallback, useEffect, useRef } from "react";
import "./rightside.css";

const handleClassShowPopup = (openPopup) => {
  return openPopup ? "right-side active" : "right-side";
};

const RightSideModel = (props) => {
  const { title, children, openPopup, setOpenPopup, width = 500 } = props;

  const content_ref = useRef(null);

  const handleEscKey = useCallback(
    (event) => {
      if (event.key === "Escape") {
        setOpenPopup(false);
      }
    },
    [setOpenPopup]
  );

  // Handle click outside the component
  const handleClickOutside = useCallback(
    (event) => {
      if (
        content_ref.current &&
        !content_ref.current.contains(event.target) &&
        !event.target.closest(".MuiAutocomplete-root") &&
        !event.target.closest(".MuiPopover-root") &&
        !event.target.closest(".MuiAutocomplete-option")
      ) {
        setOpenPopup(false);
      }
    },
    [setOpenPopup]
  );

  useEffect(() => {
    document.addEventListener("keyup", handleEscKey, false);
    document.addEventListener("mousedown", handleClickOutside, false);

    // Cleanup function
    return () => {
      document.removeEventListener("keyup", handleEscKey, false);
      document.removeEventListener("mousedown", handleClickOutside, false);
    };
  }, [handleEscKey, handleClickOutside]);

  const dynamicStyles = {
    "--width": `${width}px`,
    "--right-position": `-${width}px`,
  };

  return (
    <div>
      <div
        ref={content_ref}
        className={`${handleClassShowPopup(openPopup)}`}
        style={dynamicStyles}
      >
        <h4 style={{ marginBottom: "20px" }}>{title}</h4>
        <button
          className="right-side__close"
          onClick={() => {
            setOpenPopup(false);
          }}
        >
          <i className="bx bx-x"></i>
        </button>
        <div>{children}</div>
      </div>
    </div>
  );
};

export default RightSideModel;
